"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextVariant = void 0;
// Variant names follow the naming from typography design tokens
let TextVariant = exports.TextVariant = /*#__PURE__*/function (TextVariant) {
  TextVariant["Display"] = "display";
  TextVariant["HeadingXL"] = "heading-xl";
  TextVariant["HeadingLG"] = "heading-lg";
  TextVariant["HeadingMD"] = "heading-md";
  TextVariant["HeadingSM"] = "heading-sm";
  TextVariant["HeadingXS"] = "heading-xs";
  TextVariant["HeadingXXS"] = "heading-xxs";
  TextVariant["BodyLG"] = "body-lg";
  TextVariant["BodyMD"] = "body-md";
  TextVariant["BodySM"] = "body-sm";
  TextVariant["BodyHint"] = "body-hint";
  TextVariant["BodyLGInteractive"] = "body-lg-interactive";
  TextVariant["BodyMDInteractive"] = "body-md-interactive";
  TextVariant["BodySMInteractive"] = "body-sm-interactive";
  TextVariant["LabelMD"] = "label-md";
  TextVariant["LabelSM"] = "label-sm";
  TextVariant["LabelXS"] = "label-xs";
  return TextVariant;
}({});